import * as React from 'react';

const SvgMoreHorizontalOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M18 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM10 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM4 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z", fill: "currentColor" })));

export { SvgMoreHorizontalOutline as default };
